export const enum AppRoutes {
  Admin = '/admin',
  Webstore = '',
}

export const enum AdminSubRoutes {
  EquipmentList = '/equipment-list',
  ManageEquipment = '/manage-equipment-data',
  Root = '/',
}
